/**
 * @file useGroup
 * @author yuzong(yuzong@tencent.com)
 */
import { useEffect } from 'react';
import { useSingleton } from '@tencent/glue-react-use';
import { Group } from '@tencent/glue-model-group';
export function useGroup(options) {
  var group = useSingleton(function () {
    return new Group(options);
  });
  group.updateGroupOptions(options);
  useEffect(function () {
    return function () {
      return group.dispose();
    };
  }, []);
  return group;
}